const PizzaMass=[
    {
        id:1,
        title:"М'ясний мікс 500г",
        price:"370 грн",
        src: require('../img/meet-mix.png'),
        text:"куряче філе, салямі, шинка, печериці,  моцарелла, томатний соус ",
    },
    {
        id:2,
        title:"Піца «Seafood» 500г",
        price:"390 грн",
        src: require('../img/seefood.png'),
        text:"вершки, гірчиця, креветки, кальмари, філе лосося, пармезан, лимон, моцарелла",
    },
    {
        id:3,
        title:"Піца «Цезар» 500г",
        price:"370 грн",
        src: require('../img/cezarpizza.png'),
        text:"томатний соус, куряче філе, помідор, лист салату, пармезан, бекон, моцарелла, соус Цезар",
    },
    {
        id:4,
        title:"чотири сири 500г",
        price:"370 грн",
        src: require('../img/six-chees.png'),
        text:"вершки, гауда, моцарелла, пармезан, дорблю ",
    },
    {
        id:5,
        title:"Салямі бум 500г",
        price:"340 грн",
        src: require('../img/salyami.png'),
        text:"салямі, помідор, перець чилі,  моцарелла, томатний соус",
    },
    // {
    //     id:13,
    //     title:"Піца зі свининою 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/pszzasvin.png'),
    //     text:"тісто, свинина, соус на піцу, огірок маринований, цибуля маринована, мацарела, бекон, перець чілі",
    // },
    // {
    //     id:14,
    //     title:"маргарита 500г/1000г",
    //     price:"245грн/325грн",
    //     src: require('../img/margaritta.png'),
    //     text:"тісто, соус на піцу, мацарела, спеції",
    // },
    // {
    //     id:15,
    //     title:"піца з мідіями 500г/1000г",
    //     price:"265грн/345грн",
    //     src: require('../img/pizzamidii.png'),
    //     text:"тісто, соус на піцу, мацарела, мідії, лимон, французька гірчиця",
    // },
    // {
    //     id:12,
    //     title:"Піца гавайська 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/havai.png'),
    //     text:"вершки, куряче філе, ананас, моцарелла, базилік",
    // },
    // {
    //     id:10,
    //     title:"Піца сирна із грушею 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/sirgrusha.png'),
    //     text:"Вершки, груша, моцарелла, дорблю, грецький горіх",
    // },
    // {
    //     id:11,
    //     title:"Піца із хамоном 500г/1000г",
    //     price:"265грн/415грн",
    //     src: require('../img/hamonmacarella2.png'),
    //     text:"вершки, хамон, пармезан, моцарелла, груша, рукола",
    // },
    // {
    //     id:2,
    //     title:"Піца баварська 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/bovar.webp'),
    //     text:"томатний соус, гірчиця французька, мисливські ковбаски, бекон, маринована цибуля, печериці, моцарелла",
    // },
    
    // {
    //     id:6,
    //     title:"Шинка-печериці 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/mushpizza.png'),
    //     text:"шинка, печериці, моцарелла, вершки, часник",
    // },
    // {
    //     id:7,
    //     title:"Піца з лососем 450г/900г",
    //     price:"295грн/395грн",
    //     src: require('../img/red-fishpizza.webp'),
    //     text:"вершковий соус, лосось, моцарелла, маслини, пармезан",
    // },
    // {
    //     id:9,
    //     title:"Піца з телятиною 500г/1000г",
    //     price:"265грн/365грн",
    //     src: require('../img/cawpizza.webp'),
    //     text:"телятина, бекон, соус томатний, цибуля ялта, перець болгарський, сир моцарела",
    // },
]

export default PizzaMass;